import { useSetUserProgressVisibilityMutation } from 'academy-common-lib/__generated__/chirp/com/hubspot/learning/center/user/progress/rpc/UserProgressVisibilityChirpService.hooks';
const MY_LEARNING_QUERY_FIELD_NAME = 'getProgressItemsForMyLearningPage';
export const useUpdateUserProgressVisibility = variables => {
  return useSetUserProgressVisibilityMutation({
    variables,
    update: (cache, result) => {
      var _result$data;
      if ((_result$data = result.data) !== null && _result$data !== void 0 && _result$data.result) {
        cache.evict({
          fieldName: MY_LEARNING_QUERY_FIELD_NAME
        });
      }
    }
  });
};